import styled from "styled-components";
import { baseColors } from "../../../themes/definitions/si/cis/base-colors";
import { LastLoginDefaultBox } from "./last-login.default.box";

export const LastLoginSICisBox = styled(LastLoginDefaultBox)`
    color: ${baseColors.base06};
    letter-spacing: 0.4px;
`;